<template>
  <div class="pt3 pb3">
    <div class="x xjb" v-if="lang === 'en'">
      <h1>Regulations</h1>
    </div>
    <div class="x xjb" v-else>
      <h1>Reglement</h1>
    </div>
    <div class="form-wrapper w100">
      <div class="c12 x xjb">
        <div class="c4 py0-5 pr1">
        </div>
        <div v-if="lang === 'en'" class="c8">
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 1</div>
            <div class="field c8">
              Organizer and legal body of the European Media Art Festival (EMAF) is the Experimental Film Workshop e. V., Lohstrasse 45a, 49074 Osnabrück, Germany.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 2</div>
            <div class="field c8">
              A maximum of three works per author can be submitted for the categories Film, Installation and Performance/Expanded Media. There is no limitation as to the running time of individual works.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 3</div>
            <div class="field c8">
              Installations and projects in the category Performance/Expanded Media must include a detailed description, photos and, if available, a video documentation.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 4</div>
            <div class="field c8">
              Deadline for entries is 31 December, 2019.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 5</div>
            <div class="field c8">
              Only films produced after December 1, 2018 are eligible for selection. Equally, concepts for installations and expanded media projects must have been finalised after this date. Exceptions are possible.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 6</div>
            <div class="field c8">
              The selection committees and curators will make their decisions about participation of a work in the festival based on the submitted material and will nominate works for the awards.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 7</div>
            <div class="field c8">
              Submitters will be notified about the selection by e-mail in the middle of March 2020.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 8</div>
            <div class="field c8">
              The EMAF pays a screening fee for every film selected from the open call. Fees range from 40 to 100 EUR depending on the running time of a work. The artist fee for installations selected for EMAF’s exhibition amounts to 300 EUR per work.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 9</div>
            <div class="field c8">
              It is in the responsibility of the artists or submitters to ensure that the public exhibition rights of a work have been cleared with all relevant parties before submitting a work. If the exhibition rights of a work are transferred to a successor in title after the program selection by EMAF has been made, the successor has to grant permission for this work to take part in the festival.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 10</div>
            <div class="field c8">
              An international jury awards the "EMAF Award" for a trend-setting filmic work in media art, and the "Dialog-Award" of the German Ministry of Foreign Affairs for the promotion of intercultural exchange. The jury of the Association of German Film Critics (VDFK) awards the "EMAF Media Art Award of the German Film Critics".
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 11</div>
            <div class="field c8">
              The EMAF may use texts and photos from the application for publicity purposes in the media and in EMAF’s publications. By signing the application, submitters declare that EMAF is released from rights claims by third parties and rights holders of texts and photos used. This includes the right to publish the texts and stills in the festival catalogue and on EMAF’s homepage.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 12</div>
            <div class="field c8">
              The EMAF has the right, after prior consultation, to use clips of selected works for publicity purposes in the media and on the festival homepage.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 13</div>
            <div class="field c8">
              All films selected for the festival become part of EMAF’s "Video Library", which is open to all festival visitors for individual viewing. For this, EMAF reserves the right to store all selected films, watermarked with EMAF’s logo, on a central server.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 14</div>
            <div class="field c8">
              The costs for postage and return postage for preview and documentation material is at the expense of the submitter. Material posted from outside the EU must be marked with the comment: “Artwork – Only for Cultural Purposes – Not for Commercial Use – Empfaenger ist Selbstverzoller!” The attached pro-forma-invoice has to state a maximum value of $10 US. All costs resulting from customs charges or handling will be reclaimed from the submitter.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 15</div>
            <div class="field c8">
              All preview materials will remain in the EMAF archive and will not be returned to the sender. Materials will only be returned on request and at the expense of the submitter.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 16</div>
            <div class="field c8">
              Preview DVDs, USB sticks or harddrives sent by post or courier must arrive in Osnabrueck before 31 December 2019.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 17</div>
            <div class="field c8">
              Screening copies or file uploads have to arrive in Osnabrueck or be uploaded on the festival server no later than 1 April 2020. After the festival, film prints and DCPs will be returned or forwarded to the address mentioned in the application.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 18</div>
            <div class="field c8">
              The costs for shipping screening copies to the festival is covered by the submitter; return shipping is arranged and paid for by the festival.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 19</div>
            <div class="field c8">
              16mm and 35mm film prints will be insured at print value during the period of the festival. Any claims for replacement due to damage are to be pleaded no later than 10 days after return from the festival.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 20</div>
            <div class="field c8">
              The application of a work implies the acceptance of the regulations of the European Media Art Festival. In case of doubts the German version applies (legal domicile is Osnabrück). 
            </div>
          </div>
        </div>
        <div v-else class="c8">
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 1</div>
            <div class="field c8">
              Veranstalter des European Media Art Festival (EMAF) ist der Experimentalfilm Workshop e.V., Lohstrasse 45a, D-49074 Osnabrück.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 2</div>
            <div class="field c8">
              Eingereicht werden können pro Autor*in maximal drei Arbeiten in den Kategorien Film, Installation und Performance/Expanded Media. Es gibt keine Begrenzung hinsichtlich der Lauflänge der Arbeiten.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 3</div>
            <div class="field c8">
              Anmeldungen von Installationen für die Ausstellung und von Projekten der Kategorie Performance/Expanded Media müssen eine ausführliche Beschreibung, Fotos und, soweit vorhanden, eine Videodokumentation beigefügt werden.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 4</div>
            <div class="field c8">
              Einreichschluss für alle Anmeldungen ist der 31. Dezember 2019.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 5</div>
            <div class="field c8">
              Die eingereichten Filme müssen nach dem 01.12.2018 fertiggestellt worden sein. Die Konzeption der Installationen und Projekte für Performance/Expanded Media sollte ebenfalls nach diesem Datum erfolgt sein. Ausnahmen sind möglich.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 6</div>
            <div class="field c8">
              Die Auswahlkommissionen und Kurator*innen entscheiden auf Grundlage der eingesandten Materialien über die Teilnahme am EMAF und die Auswahl für die einzelnen Festivalsektionen. Sie sprechen Nominierungen für die beim EMAF verliehenen Preise aus.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 7</div>
            <div class="field c8">
              Die Einreicher*innen werden ab Mitte März 2020 per E-Mail über die Entscheidungen der Auswahlkommissionen benachrichtigt.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 8</div>
            <div class="field c8">
              Für die aus diesem Call ausgewählten Filme werden je nach Laufzeit Leihmieten zwischen 40 und 100 EUR gezahlt; die ausgewählten Ausstellungsbeiträge werden mit je 300 EUR honoriert.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 9</div>
            <div class="field c8">
              Die Einreicher*innen stellen vor Anmeldung einer Arbeit sicher, dass die Vorführrechte für das EMAF gegenüber an der Produktion beteiligten Dritten und sonstigen Rechteinhabern vorliegen. Falls in der Zeit zwischen Einreichung und Aufführung der Arbeit auf dem EMAF der/die Rechteinhaber*innen wechseln, muss dem EMAF dessen/deren Zustimmung zur Teilnahme am Festival schriftlich mitgeteilt werden.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 10</div>
            <div class="field c8">
              Auf dem Festival werden von einer internationalen Jury der "EMAF-Award" für eine richtungsweisende filmische Arbeit in der Medienkunst und der "Dialogpreis" des Auswärtigen Amtes für eine Arbeit vergeben, die der Förderung des interkulturellen Austausches dient. Zudem verleiht die Jury des Verbands der Deutschen Filmkritik (VDFK) den "EMAF-Medienkunst-Preis der Deutschen Filmkritik".
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 11</div>
            <div class="field c8">
              Das EMAF nutzt die Texte und Fotos aus der Anmeldung zur Veröffentlichung in den Medien, den Publikationen des EMAF und auf der Festival-Homepage. Der/die Anmelder*in stellt das EMAF durch Anerkennung des Reglements von Rechten Dritter an Texten und Fotos frei.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 12</div>
            <div class="field c8">
              Das Festival darf nach Rücksprache mit den Autor*innen bzw. Anmelder*innen Ausschnitte der ausgewählten Arbeiten in den Medien und auf der Homepage des EMAF veröffentlichen.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 13</div>
            <div class="field c8">
              Alle für das Programm des EMAF ausgewählten Filme sind on demand auch in der "Video Library" des EMAF zu sehen. Dazu werden Kopien der Arbeiten auf einem zentralen Server gespeichert und mit einem EMAF-Wasserzeichen versehen. Die "Video Library" steht allen EMAF Besucher*innen zur individuellen Sichtung der Beiträge zur Verfügung.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 14</div>
            <div class="field c8">
              Die Kosten für Hin- und Rückversand postalisch eingesandter Sichtungsmaterialien gehen zu Lasten der Einsender*innen (unfreie Sendungen werden verweigert). Sendungen aus Nicht-EU-Ländern müssen den Hinweis tragen: „Nur für kulturelle Zwecke – keine kommerzielle Nutzung. Empfänger ist Selbstverzoller“. Der Wert im Proforma-Invoice oder auf dem Paketschein darf 10 US$ nicht überschreiten. Zoll- und Sicherungsgebühren gehen zu Lasten der Versender*innen.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 15</div>
            <div class="field c8">
              Die eingereichten Sichtungsmaterialien werden nur auf ausdrücklichen Wunsch der Einreicher*innen und gegen Übernahme der Versandkosten zurückgesandt und verbleiben andernfalls im Archiv des EMAF.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 16</div>
            <div class="field c8">
              Auf DVD oder anderen Datenträgern eingereichte Sichtungskopien müssen bis zur Deadline 31.12.2019 in Osnabrück eingetroffen sein.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 17</div>
            <div class="field c8">
              Die Vorführkopien müssen bis zum 01.04.2019 in Osnabrück eingetroffen bzw. auf den EMAF-Server hochgeladen sein. DCPs und Filmkopien werden nach dem Festival an die angegebene Adresse zurück- bzw. weitergesandt.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 18</div>
            <div class="field c8">
              Die Kosten für den Hinversand der Vorführkopien gehen zu Lasten der Einreicher*innen, die für den Rückversand übernimmt das Festival.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 19</div>
            <div class="field c8">
              Filmkopien in den Formaten 16mm und 35mm sind während der Veranstaltung mit ihrem Kopienwert versichert. Etwaige Schadensersatzansprüche sind bis spätestens 10 Tage nach Rücksendung geltend zu machen.
            </div>
          </div>
          <div class="input-wrapper c12 x">
            <div class="label bold c4 py0-5">⟼ 20</div>
            <div class="field c8">
              Die Anmeldung einer Arbeit bedeutet die Anerkennung des Reglements des European Media Art Festival. Im Zweifel gilt die deutsche Fassung (Gerichtsstand ist Osnabrück).
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Regulations',
  computed: {
    lang () {
      return this.$store.state.language
    }
  }
}
</script>

<style scoped>
.label {
  font-feature-settings: 'tnum';
}
</style>
